<template>
    <v-container class="pt-0 pb-5">
        <v-row>
            <v-col cols="12">
                <div class="pa-2 rounded elevation-1 bg-white">
                    <div>
                        <router-link :to="{ name: 'Home', params: { base_module: mainStore.module.base } }">
                            <v-btn density="compact" variant="outlined" color="primary-dark" text>
                                <v-icon>mdi-arrow-left</v-icon>
                                Retour à l'accueil
                            </v-btn>
                        </router-link>
                    </div>
                    <div class="text-h6 mt-2">Bourse aux dossards de {{ mainStore.module.nom }}</div>
                    <!-- Liste des inscriptions -->
                    <BourseDossardList></BourseDossardList>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import BourseDossardList from "@/components/BourseDossards/BourseDossardsList.vue";

export default {
    components: { BourseDossardList },
    name: 'BourseDossardsView',
    computed: {
        ...mapStores(useMainStore),
    },
}
</script>

<style lang="scss" scoped></style>